<template>
    <BaseModal
        :title="$t('title')"
        class="maintenance-form-modal"
        v-on="$listeners"
    >
        <MaintenanceForm
            ref="form"
            :asset-id="assetId"
            :policy-id="policyId"
            @disabled="isDisabled = $event"
            @loading="isLoading = $event"
        />

        <template #footer>
            <div class="l-inline l-justify-end">
                <BaseButton
                    size="small"
                    :is-loading="isLoading"
                    :disabled="isDisabled"
                    @click="handleSubmit"
                >
                    {{ $t('shared.save') }}
                </BaseButton>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseButton from './BaseButton'
import BaseModal from './BaseModal'
import MaintenanceForm from '../MaintenanceForm'

export default {
    name: 'MaintenanceFormModal',
    components: {
        BaseButton,
        BaseModal,
        MaintenanceForm,
    },
    props: {
        assetId: {
            type: Number,
            default: null,
        },
        policyId: {
            type: Number,
            default: null,
        },
        onSubmit: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            isDisabled: false,
            isLoading: false,
        }
    },
    methods: {
        async handleSubmit() {
            this.isLoading = true
            await this.$refs.form.handleSubmit()
            this.onSubmit?.()
            this.$emit('close')
        },
    },
}
</script>

<i18n>
{
    "en": {
        "title": "Add a new maintenance record"
    },
    "de": {
        "title": "Neuen Wartungssatz hinzufügen"
    },
    "fr": {
        "title": "Ajouter un nouvel de maintenance"
    },
    "it": {
        "title": "Aggiungere un nuovo record di manutenzione"
    }
}
</i18n>

<style lang="scss">
.maintenance-form-modal {
    .maintenance-form {
        button[type='submit'] {
            display: none;
        }
    }
}
</style>
